import React from "react";
import LEVELS from "./levels";

const SatisfactionTable = ({ printerData }) => {
  if (!printerData || printerData.length === 0) {
    return (
      <div className="text-gray-600 dark:text-gray-400">No data available</div>
    );
  }

  // Overall figures across every printer; the average is weighted by vote count
  const totals = { count: 0, sum: 0 };
  LEVELS.forEach(({ key }) => {
    totals[key] = 0;
  });
  printerData.forEach((item) => {
    totals.count += item.count ?? 0;
    totals.sum += (item.average ?? 0) * (item.count ?? 0);
    LEVELS.forEach(({ key }) => {
      totals[key] += item.points?.[key] ?? 0;
    });
  });
  const overallAverage =
    totals.count > 0 ? (totals.sum / totals.count).toFixed(2) : "0";

  const tableData = printerData.map((item) => (
    <tr key={item.printerId} className="text-gray-700 dark:text-gray-400">
      <td className="px-4 py-3 text-sm">{item.printerName}</td>
      <td className="px-4 py-3 text-sm">{item.location}</td>
      <td className="px-4 py-3 text-sm font-semibold">
        {item.average?.toFixed(2) ?? "0"}
      </td>
      <td className="px-4 py-3 text-sm">
        {(item.count ?? 0).toLocaleString()}
      </td>
      {LEVELS.map(({ key }) => (
        <td key={key} className="px-4 py-3 text-sm">
          {(item.points?.[key] ?? 0).toLocaleString()}
        </td>
      ))}
    </tr>
  ));

  tableData.push(
    <tr
      key="total"
      className="font-semibold text-gray-700 dark:text-gray-300"
    >
      <td className="px-4 py-3 text-sm" colSpan="2">
        Total
      </td>
      <td className="px-4 py-3 text-sm">{overallAverage}</td>
      <td className="px-4 py-3 text-sm">{totals.count.toLocaleString()}</td>
      {LEVELS.map(({ key }) => (
        <td key={key} className="px-4 py-3 text-sm">
          {totals[key].toLocaleString()}
        </td>
      ))}
    </tr>
  );

  return (
    <div className="w-full overflow-hidden rounded-lg shadow-xs">
      <div className="w-full overflow-x-auto">
        <table className="w-full whitespace-no-wrap">
          <thead>
            <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
              <th className="px-4 py-3">Printer</th>
              <th className="px-4 py-3">Location</th>
              <th className="px-4 py-3">Average (of 5)</th>
              <th className="px-4 py-3">Votes</th>
              {LEVELS.map(({ key, name }) => (
                <th key={key} className="px-4 py-3">
                  {name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
            {tableData}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SatisfactionTable;
